import { useRefract } from "refract-rxjs";

import { type ApolloResult } from "../../shared/models";
import { type LensOrganicStatsInput, type LensOrganicStatsOutput, getOrganicLensStatsEffect } from "../effects";
import { type LensStatsItem } from "../models";

import { useLensStatsQuery } from "./useLensStatsQuery";

export const useOrganicLensStats = (lensId: string): ApolloResult<{ stats: LensStatsItem[] }> => {
    const { data, error, loading } = useLensStatsQuery(lensId);

    const { stats } = useRefract<LensOrganicStatsInput, LensOrganicStatsOutput>(getOrganicLensStatsEffect, {
        data,
        loading,
    });

    return { loading, error, stats };
};
